module.exports = __webpack_public_path__ + "img/6.9bf5124a.jpg";